import { GraphicsRenderRepair } from '../digital-twin/graphics/graphics-render-repair';
import { HostListener, Injectable, Injector, OnDestroy } from '@angular/core';
import { Util } from '@phdsoft/common';
import { AssetManager, FunctionalityMode } from './asset-manager';
import { CollectionStaticData } from '../collections/_utils/collection.static.data';
import { RepairInsertion } from '../insertion-logic/repair-insertion';
import { RulerInsertion } from '../insertion-logic/ruler-insertion';
import { GraphicsRenderControls } from '../digital-twin/graphics/graphics-render-controls';
import { GaugingElement } from '../platform/busines-data/SectionElements/InspectionElements/gaugingElement';
import { GraphicsMaterials } from '../digital-twin/graphics/graphics-materials';
import { v4 as uuid } from 'uuid';
import { Graphics } from '../digital-twin/graphics/graphics';
import { RepairCampaign } from '../platform/busines-data/Campaigns/RepairCampaign';
import { SurfaceElement } from '../platform/busines-data/SectionElements/StructureElements/SurfaceElement';
import { LinearElement } from '../platform/busines-data/SectionElements/StructureElements/LinearElement';
import { ELEMENTSTYPESIDS } from 'projects/phdsoft/common/src/lib/shared/constants/elementsTypesIds';
import { mergeGeometries, mergeVertices } from 'three/examples/jsm/utils/BufferGeometryUtils.js';
import * as THREE from '@phdsoft/three';
import { BufferGeometry } from '@phdsoft/three';
import { StructuralElement } from '../platform/busines-data/SectionElements/StructureElements/StructuralElement';
import { RepairService } from '../shared/services/repair.service';
import { GeometryModel } from 'projects/phdsoft/common/src/lib/models/repairmodels/repair.model';
import { ClusterService } from '../cluster/cluster.service';
import { NotificationService } from '../signalr/notification.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { InspectionPlanService } from '../inspection-plan/inspection-plan.service';
import { ActionsService } from '@app/admin/pages/risk-setup/service/actions.service';
import { BehaviorSubject, firstValueFrom, merge } from 'rxjs';
import { RepairCommandService } from '@app/shared/command/repair/repair-command.service';
import { CommandManager } from '@app/shared/command/command-manager.service';
import { DigitalTwinService } from '../digital-twin/digital-twin.service';
import { DTSelectionService } from '../digital-twin/selection/selection.service';
import { AssetManagerTools } from './asset-manager-tools';
import { GeometryExtrusionComputer } from '@app/geometry-extrusion/geometry-extrusion-computer';
import { PlanExecutionService } from '../shared/services/plan-execution.service';
import { LightSectionModService } from '@app/digital-twin/Loader/LightSectionModService';

@Injectable({ providedIn: 'root' })
export class AssetManagerRepair implements OnDestroy {

  //#region Centralized getters/setters using asset-manager

  private get _currentRepairCampaign(): RepairCampaign {
    return this.assetManager._currentRepairCampaign;
  }

  private set _currentRepairCampaign(value: RepairCampaign) {
    this.assetManager._currentRepairCampaign = value;
  }

  private get functionalityMode(): FunctionalityMode {
    return this.assetManager.functionalityMode;
  }

  private set functionalityMode(value: FunctionalityMode) {
    this.assetManager.functionalityMode = value;
  }

  private get elementTypeForInsertionAndSelectionGuid(): string {
    return this.assetManager.elementTypeForInsertionAndSelectionGuid;
  }

  //#endregion

  constructor(
    private graphicsRenderRepair: GraphicsRenderRepair,
    private graphicsRenderControl: GraphicsRenderControls,
    private graphics: Graphics,
    public clusterService: ClusterService,
    public noticationService: NotificationService,
    private assetManager: AssetManager,
    private repairInsertion: RepairInsertion,
    private rulerInsertion: RulerInsertion,
    private repairService: RepairService,
    private snackBar: MatSnackBar,
    private inspectionPlanService: InspectionPlanService,
    private actionsService: ActionsService,
    private digitalTwinService: DigitalTwinService,
    private injector: Injector,
    private planExecutionService: PlanExecutionService,
    private lightSectionModService: LightSectionModService,
    // private repairCommandService: RepairCommandService,
    // private commandManager: CommandManager,
  ) {
  }

  private _selectionService: DTSelectionService | null = null;
  private get selectionService(): DTSelectionService {
    if (!this._selectionService) {
      this._selectionService = this.injector.get(DTSelectionService);
    }
    return this._selectionService;
  }

  private _assetManagerTools: AssetManagerTools | null = null;
  private get assetManagerTools(): AssetManagerTools {
    if (!this._assetManagerTools) {
      this._assetManagerTools = this.injector.get(AssetManagerTools);
    }
    return this._assetManagerTools;
  }

  @HostListener('unloaded')
  ngOnDestroy(): void {
    console.log('💣 Destroy AssetManagerRepair');
  }

  public startRepairCollectionMode(argument, cut: boolean): void {
    this.functionalityMode = argument == false ? 'MANUALREPAIR' : 'SPLITMANUALREPAIR';
    // if (Util.isNullOrUndefined(this.graphics.currentSection)) {
    //   if (this.graphics.sectionNavigator.length === 1) {
    //     this.graphics.currentSection = this.graphics.sectionNavigator[0];
    //   }
    // }
    this.assetManager.showAllSectionsInspectionsWhenInRepair()

    this.graphics.Controls.enableRotate = false
    this.graphics.hammerManager.get('pan').set({ enable: true });
    this.graphicsRenderRepair.rectd.isCut = cut;
  }

  public setRepairCutNone() {
    this.graphicsRenderRepair.rectd.isCut = false;
  }

  public isCut(): boolean {
    return this.graphicsRenderRepair.rectd.isCut;
  }

  private _isCutPlateOnly: boolean = false;

  public isCutPlateOnly(): boolean {
    return this._isCutPlateOnly;
  }

  public setCutPlateOnly(value: boolean): void {
    this._isCutPlateOnly = value;
  }

  public StartInsertionEvent(ev): void {
    switch (this.functionalityMode) {
      case 'INSPECTIONINSERTION':
        this.graphicsRenderRepair.setRepairMode("manual")
        this.graphicsRenderRepair.setElementType(this.elementTypeForInsertionAndSelectionGuid)
        this.repairInsertion.insertRepair(ev)
        break;
      case 'ELEMENTINSERTION':
        this.graphicsRenderRepair.setRepairMode("manual")
        this.graphicsRenderRepair.setElementType(this.elementTypeForInsertionAndSelectionGuid)
        this.repairInsertion.insertRepair(ev)
        break;
      case 'MANUALREPAIR':
        this.graphicsRenderRepair.setRepairMode("manual")
        this.graphicsRenderRepair.setElementType(this.elementTypeForInsertionAndSelectionGuid)
        if (this.elementTypeForInsertionAndSelectionGuid === ELEMENTSTYPESIDS.STIFFENER ||
          this.elementTypeForInsertionAndSelectionGuid === ELEMENTSTYPESIDS.BRACKET || this.elementTypeForInsertionAndSelectionGuid === ELEMENTSTYPESIDS.FACEPLATE) {
          this.graphicsRenderRepair.setRepairMode("split")
        }
        this.repairInsertion.insertRepair(ev)
        break;
      case 'CRITICALAREA':
        this.graphicsRenderRepair.setRepairMode(this.isOnLinearElement(this.elementTypeForInsertionAndSelectionGuid) ? 'split' : "manual");
        this.graphicsRenderRepair.setElementType(this.elementTypeForInsertionAndSelectionGuid)
        this.repairInsertion.insertRepair(ev)
        break;
      case 'SPLITCRITICALAREA':
        this.graphicsRenderRepair.setRepairMode("split")
        this.graphicsRenderRepair.setElementType(this.elementTypeForInsertionAndSelectionGuid)
        this.repairInsertion.insertRepair(ev)
        break;
      case 'SPLITMANUALREPAIR':
        this.graphicsRenderRepair.setRepairMode("split")
        this.graphicsRenderRepair.setElementType(this.elementTypeForInsertionAndSelectionGuid)
        this.repairInsertion.insertRepair(ev)
        break;
      case 'ZOOMBOX':
        this.graphicsRenderControl.insertZoomBox(ev)
        break;
      case 'STIFFNERINSERTION':
        this.rulerInsertion.insertRuler(ev)
        break;
      case 'CUTPLATE':
        this.rulerInsertion.insertRuler(ev)
        break;
      case 'CUTPLATESHAPE':
        this.graphicsRenderRepair.setRepairMode("manual")
        this.graphicsRenderRepair.setElementType(ELEMENTSTYPESIDS.PLATE)
        this.graphicsRenderRepair.threeStartGeometryCloning();
        this.repairInsertion.insertRepair(ev)
        break;
      case 'WELDINGINSERTION':
        // TODO
        break;
      case 'MEASURETOOLS':
        this.rulerInsertion.insertRuler(ev)
        break;
      default:
        break;
    }
  }

  //#region Finish Insert Repair
  public FinishInsertRepair(): void {
    this.FinishInsertRepairModeManualRepair();
  }

  private async FinishInsertRepairModeManualRepair() {
    if (!this.isSavingRepair) {
      // Handle cut-plate-only operation (no repair element creation)
      // Check both isCutPlateOnly flag AND functionalityMode to handle consecutive cuts
      const isCutPlateShapeMode = this.isCutPlateOnly() || this.functionalityMode === 'CUTPLATESHAPE';
      if (isCutPlateShapeMode && !Util.isNullOrUndefined(this.graphicsRenderRepair.rectd.meshs) && this.graphicsRenderRepair.rectd.meshs.length > 0) {
        // Merge vertices on the cut mesh
        const _mesh = this.graphicsRenderRepair.rectd.meshs[0];
        if (_mesh?.geometry instanceof BufferGeometry) {
          _mesh.geometry = mergeVertices(_mesh?.geometry as BufferGeometry);
        }

        const targets = this.graphicsRenderRepair.rectd.targets.map(t => {
          const target = this.assetManager.asset.getStructureAndRepairsElements(false).find(x => x.Guid === t.name);
          return target;
        }).filter(t => t != null);

        if (targets.length > 0) {
          // Enter preview mode: render the cut geometry on scene with distinct material
          for (const mesh of this.graphicsRenderRepair.rectd.meshs) {
            const previewMesh = new THREE.Mesh(mesh.geometry, GraphicsMaterials.cutPreviewMaterial);
            this._previewMeshes.push(previewMesh);
            this.graphics.scene.add(previewMesh);
          }
          this._previewTargets = [...targets];
          this._previewMeshsPerTarget = [...this.graphicsRenderRepair.rectd.meshsPerTarget];
          this.isCutPreviewing.next(true);
        }
        return;
      }

      // Repair area preview: MANUALREPAIR / SPLITMANUALREPAIR show preview before persisting
      const isRepairAreaMode = (this.functionalityMode === 'MANUALREPAIR' || this.functionalityMode === 'SPLITMANUALREPAIR') && !this.isCutPlateOnly();
      if (isRepairAreaMode && !Util.isNullOrUndefined(this.graphicsRenderRepair.rectd.meshs) && this.graphicsRenderRepair.rectd.meshs.length > 0) {
        for (const mesh of this.graphicsRenderRepair.rectd.meshs) {
          if (mesh?.geometry instanceof BufferGeometry) {
            mesh.geometry = mergeVertices(mesh.geometry as BufferGeometry);
            mesh.geometry = AssetManagerRepair.connectRepairElementGeometry(mesh.geometry as BufferGeometry);
          }
        }
        for (const mesh of this.graphicsRenderRepair.rectd.meshs) {
          const previewMesh = new THREE.Mesh(mesh.geometry, GraphicsMaterials.cutPreviewMaterial);
          this._repairPreviewMeshes.push(previewMesh);
          this.graphics.scene.add(previewMesh);
        }
        this.isRepairAreaPreviewing.next(true);
        return;
      }

      if (Util.isNullOrUndefined(this._currentRepairCampaign)) {
        this.addNewRepairCollection(new Date(), null, null, null);
      }
      if (!Util.isNullOrUndefined(this.graphicsRenderRepair.rectd.meshs)) {
        if (this.elementTypeForInsertionAndSelectionGuid === ELEMENTSTYPESIDS.STIFFENER ||
          this.elementTypeForInsertionAndSelectionGuid === ELEMENTSTYPESIDS.BRACKET || this.elementTypeForInsertionAndSelectionGuid === ELEMENTSTYPESIDS.FACEPLATE)
          {
            let elementsList:Array<{mesh:any, target: LinearElement}> = [];
            for (let i = 0; i < this.graphicsRenderRepair.rectd.meshs.length; i++) {
              const _mesh = this.graphicsRenderRepair.rectd.meshs[i];
              if (_mesh?.geometry instanceof BufferGeometry)
                _mesh.geometry = mergeVertices(_mesh?.geometry as BufferGeometry);
              const target = this.graphicsRenderRepair.rectd.targets[i];
              const _target = this.assetManager.asset.getStructureAndRepairsElements(false).find(x => x.Guid === target.name);
              if (_target){
                elementsList.push({mesh:_mesh, target:_target as LinearElement});
              }
            }
            const groupedByMaterialAndThickness:Array<Array<{mesh:any, target: LinearElement}>> = []

            for (const element of elementsList) {
              let index = groupedByMaterialAndThickness.findIndex( x=> x.findIndex(y => y.target.MaterialType.Guid === element.target.MaterialType.Guid &&
                y.target.thickness === element.target.thickness  && y.target.isFlange === element.target.isFlange) > -1);
              if(index > -1){
                groupedByMaterialAndThickness[index].push(element);
              }
              else{
                groupedByMaterialAndThickness.push([element]);
              }
            }

            if (this.graphicsRenderRepair.rectd.isCut) {
              let index = 0;
              for (const targetCut of groupedByMaterialAndThickness) {
                let targets = [];
                let geometries = [];

                for (const item of targetCut) {
                  targets.push(item.target);
                  geometries.push(item.mesh.geometry);
                }
    var mergedGeometry = mergeGeometries(geometries);

                var Id = uuid() as string
                // const clone = new LinearElement(_mesh, this.graphicsMaterials.hatchingMaterial, uuid() as string);
                const clone = targets[0].clone() as LinearElement;
                clone.SurfaceDesign = new THREE.Mesh(mergedGeometry, GraphicsMaterials.hatchingMaterial);
                clone.defaultMaterial = GraphicsMaterials.hatchingMaterial;
                clone.currentMaterial = GraphicsMaterials.hatchingMaterial;
                clone.outlinedMaterial = GraphicsMaterials.hatchingMaterial;
                // clone.Guid = uuid().replace(/-/g, '') as string;
                clone.Guid = Id;
                clone.SurfaceDesign.name = Id;
                clone.SurfaceDesign.geometry.computeBoundingBox();
                clone.SurfaceDesign.geometry.computeBoundingSphere();
                clone.SurfaceDesign.geometry.computeVertexNormals();
                clone.SurfaceDesign.userData.scale = 1;
                clone.CreationCommandType = 'RepairElement';
                clone.targetIds =  targets.map(x => x.Guid);

                clone.isRepair = true;
                clone.isDoubler = false;
                clone.targetId =  targets[0].name;
                const rdLin = this.assetManager.referenceDate;
                clone.date = new Date(Date.UTC(rdLin.getFullYear(), rdLin.getMonth(), rdLin.getDate()));
                var inspections = this.graphicsRenderRepair.rectd.inspections.filter(x => clone.targetIds.includes(x.elementResult.TargetGeometryId) ||
                                        clone.targetIds.includes(x.elementResult.TargetGeometryId.replace(/-/g, '') as string));
                clone.inspectionsSolved = inspections;
                clone.executionStatus = 'OUTLINED';
                clone.isExecuted = false;
                clone.properties.ElementId = clone.Guid;
                switch (clone.TypeId) {
                  case ELEMENTSTYPESIDS.STIFFENER:
                    clone.executedMaterial = GraphicsMaterials.stiffenerMaterial3d;
                    break;
                  case ELEMENTSTYPESIDS.FACEPLATE:
                    clone.executedMaterial = GraphicsMaterials.flangeMaterial3d;
                    break;
                  case ELEMENTSTYPESIDS.BRACKET:
                    clone.executedMaterial = GraphicsMaterials.bracketMaterial3d;
                    break;
                  default:
                    break;
                }
                if (clone.properties.General.CompleteStiffenerLabel) {
                  clone.properties.General.CompleteStiffenerLabel = this.generateNewCompleteStiffenerRepairLabel(clone)
                }

                if (clone.properties.General.CompleteBracketLabel) {
                  clone.properties.General.CompleteBracketLabel = this.generateNewCompleteBracketRepairLabel(clone)
                }
                clone.properties.General.Label = this.generateNewRepairLabel(clone)
                // clone.properties.General.Label = clone.properties.General.Label + '_1' // TODO
                clone.properties.General.Collection = {
                  Date: clone.date,
                  Id: uuid() as string,
                  Name: "Repair Collection",
                  Report: "Repair"
                }
                clone.createBorder(GraphicsMaterials.borderMaterialLineBasic);
                clone.MaterialType = this.assetManager.asset.materials.find(x => x.Guid === clone.properties?.General?.MaterialId);
                clone.ComputeAttributes();
                clone.setComputedProperties(clone.meanThicknessValue);

                this._currentRepairCampaign.addLinearElement(clone, targets[0]);
                await this.upsertRepair(clone);
                // Register for undo - clone now has all properties after upsertRepair
                // this.repairCommandService.registerInsertCommand(clone);
              }
            } else {
              for (const targetDoubler of groupedByMaterialAndThickness) {
                let targets = [];
                let geometries = [];

                for (const item of targetDoubler) {
                  targets.push(item.target);
                  geometries.push(item.mesh.geometry);
                }
                var mergedGeometry = mergeGeometries(geometries);

                var Id = uuid() as string;
                const clone = targets[0].clone() as LinearElement;
                clone.SurfaceDesign = new THREE.Mesh(mergedGeometry, GraphicsMaterials.hatchingMaterial);
                clone.defaultMaterial = GraphicsMaterials.hatchingMaterial;
                clone.currentMaterial = GraphicsMaterials.hatchingMaterial;
                clone.outlinedMaterial = GraphicsMaterials.hatchingMaterial;
                clone.Guid = Id;
                clone.SurfaceDesign.name = Id;
                clone.SurfaceDesign.geometry.computeBoundingBox();
                clone.SurfaceDesign.geometry.computeBoundingSphere();
                clone.SurfaceDesign.geometry.computeVertexNormals();
                clone.SurfaceDesign.userData.scale = 1;
                clone.CreationCommandType = 'RepairElement';
                clone.targetIds = targets.map(x => x.Guid);

                clone.isRepair = true;
                clone.isDoubler = true;
                clone.targetId = targets[0].name;
                const rdLinD = this.assetManager.referenceDate;
                clone.date = new Date(Date.UTC(rdLinD.getFullYear(), rdLinD.getMonth(), rdLinD.getDate()));
                var inspections = this.graphicsRenderRepair.rectd.inspections.filter(x => clone.targetIds.includes(x.elementResult.TargetGeometryId) ||
                                        clone.targetIds.includes(x.elementResult.TargetGeometryId.replace(/-/g, '') as string));
                clone.inspectionsSolved = inspections;
                clone.executionStatus = 'OUTLINED';
                clone.isExecuted = false;
                clone.properties.ElementId = clone.Guid;
                switch (clone.TypeId) {
                  case ELEMENTSTYPESIDS.STIFFENER:
                    clone.executedMaterial = GraphicsMaterials.stiffenerMaterial3d;
                    break;
                  case ELEMENTSTYPESIDS.FACEPLATE:
                    clone.executedMaterial = GraphicsMaterials.flangeMaterial3d;
                    break;
                  case ELEMENTSTYPESIDS.BRACKET:
                    clone.executedMaterial = GraphicsMaterials.bracketMaterial3d;
                    break;
                  default:
                    break;
                }
                if (clone.properties.General.CompleteStiffenerLabel) {
                  clone.properties.General.CompleteStiffenerLabel = this.generateNewCompleteStiffenerRepairLabel(clone);
                }
                if (clone.properties.General.CompleteBracketLabel) {
                  clone.properties.General.CompleteBracketLabel = this.generateNewCompleteBracketRepairLabel(clone);
                }
                clone.properties.General.Label = this.generateNewRepairLabel(clone);
                clone.properties.General.Collection = {
                  Date: clone.date,
                  Id: uuid() as string,
                  Name: "Repair Collection",
                  Report: "Repair"
                };
                clone.createBorder(GraphicsMaterials.borderMaterialLineBasic);
                clone.MaterialType = this.assetManager.asset.materials.find(x => x.Guid === clone.properties?.General?.MaterialId);
                clone.ComputeAttributes();
                clone.setComputedProperties(clone.meanThicknessValue);

                this._currentRepairCampaign.addLinearElement(clone, targets[0]);
                await this.upsertRepair(clone);
              }
            }
          }
          else
          {
            for (let i = 0; i < this.graphicsRenderRepair.rectd.meshsPerTarget.length; i++) {
              const _mesh = this.graphicsRenderRepair.rectd.meshsPerTarget[i];
              if (_mesh?.geometry instanceof BufferGeometry)
                _mesh.geometry = mergeVertices(_mesh?.geometry as BufferGeometry);
            }
            for (let i = 0; i < this.graphicsRenderRepair.rectd.meshs.length; i++) {
              const _mesh = this.graphicsRenderRepair.rectd.meshs[i];
              if (_mesh?.geometry instanceof BufferGeometry)
                _mesh.geometry = mergeVertices(_mesh?.geometry as BufferGeometry);
              const target = this.graphicsRenderRepair.rectd.targets[i];

              const _target = this.assetManager.asset.getStructureAndRepairsElements(false).find(x => x.Guid === target.name);
              if (_target) {
                if (_target instanceof SurfaceElement) {
                  let targets = [];

                  var Id = uuid() as string


                  // if (this.graphicsRenderRepair.rectd.isCut)
                  {
                    let index = 0;
                    for (const targetCut of this.graphicsRenderRepair.rectd.targets) {
                      const geometries = [];
                      // for (const meshes of this.graphicsRenderRepair.rectd.meshsAfterCut)
                      {
                        const _targetMeshSurface = this.assetManager.asset.getStructureAndRepairsElements(false).find(x => x.Guid === targetCut.name);
                        if (!_targetMeshSurface)
                          continue;
                        targets.push(_targetMeshSurface.Guid);
                        index++;
                      }
                    }
                  }



                  // _target.SurfaceDesign.parent.add(plateCut);
                  const clone = _target.clone(this.getRepairCounter(target.name)) as SurfaceElement;
                  // const clone = new SurfaceElement(_mesh, this.graphicsMaterials.hatchingMaterial, uuid() as string);
                  clone.SurfaceDesign = _mesh;
                  // clone.Campaign = new SurfaceElement();
                  clone.defaultMaterial = GraphicsMaterials.hatchingMaterial;
                  clone.currentMaterial = GraphicsMaterials.hatchingMaterial;
                  clone.outlinedMaterial = GraphicsMaterials.hatchingMaterial;
                  // clone.Guid = uuid().replace(/-/g, '') as string;
                  clone.Guid = Id;
                  clone.SurfaceDesign.name = Id;
                  clone.SurfaceDesign.geometry.computeBoundingBox();
                  clone.SurfaceDesign.geometry.computeBoundingSphere();
                  clone.SurfaceDesign.geometry.computeVertexNormals();
                  clone.SurfaceDesign.userData.scale = 1;
                  clone.CreationCommandType = 'RepairElement';
                  clone.targetIds = targets;
                  // clone.executedMaterial = GraphicsMaterials.executedRepairMaterial;
                  clone.createBorder(GraphicsMaterials.borderMaterialLineBasic);
                  clone.inspectionsSolved = this.graphicsRenderRepair.rectd.inspections;
                  clone.executionStatus = 'OUTLINED';
                  clone.isExecuted = false;
                  clone.isRepair = true;
                  clone.targetId = target.name;
                  // clone.properties.General.Label = this.generateNewRepairLabel(clone)
                  // clone.properties.General.Label = clone.properties.General.Label + '_1'; // TODO
                  clone.properties.ElementId = clone.Guid;

                  const rdSurf = this.assetManager.referenceDate;
                  clone.date = new Date(Date.UTC(rdSurf.getFullYear(), rdSurf.getMonth(), rdSurf.getDate()));
                  if (this.graphicsRenderRepair.rectd.isCut) {
                    clone.isDoubler = false;
                    clone.executedMaterial = GraphicsMaterials.executedRepairMaterial;
                  }
                  else{
                    clone.isDoubler = true;
                    clone.executedMaterial = GraphicsMaterials.doublerBasicMaterial;
                  }

                  clone.properties.General.Collection = {
                    Date: clone.date,
                    Id: uuid().replace(/-/g, '') as string,
                    Name: "Repair Collection",
                    Report: "Repair"
                  }
                  clone.MaterialType = this.assetManager.asset.materials.find(x => x.Guid === clone.properties?.General?.MaterialId);
                  clone.ComputeAttributes();
                  clone.setComputedProperties(clone.meanThicknessValue);
                  this._currentRepairCampaign.addSurfaceElement(clone);
                  await this.upsertRepair(clone, this.graphicsRenderRepair.rectd.meshsPerTarget);
                  // Register for undo - clone now has all properties after upsertRepair
                  // this.repairCommandService.registerInsertCommand(clone);
                  // const repair = new SurfaceElement(_mesh, _target);
                }
              }
            }
          }




        this.graphicsRenderRepair.rectd.meshs = []
        this.graphicsRenderRepair.rectd.targets = []
        // The clones' createBorder above ran outside loadAndRenderRepair when upsertRepair failed or was skipped
        this.applyRepairBorderSetting();
      }
    }
    else {
      this.snackBar.open('Please Wait while we finish saving the repair', '', {
        horizontalPosition: 'right',
        verticalPosition: 'bottom',
        duration: 3000
      });
    }
  }

  //#endregion

  private addNewRepairCollection(
    pDate?: Date,
    CurrentMethodId?: string,
    CurrentInspectionTypeId?: string,
    InpectionTypeName?: string,
  ): RepairCampaign {
    let _newCollection = new RepairCampaign(
      this.assetManager.AddCollectionIntegration(
        pDate,
        null,
        CollectionStaticData.COLLECTION_TYPE_INSPECTION_ID,
        CurrentMethodId,
        CurrentInspectionTypeId,
        InpectionTypeName,
        false
      ),
      pDate,
    )
    this.assetManager.asset.addRepairCollection(_newCollection)
    this._currentRepairCampaign = _newCollection
    return _newCollection
  }

  public async loadRegionRepairs(assetId: string, regionId: string, referenceDate: Date) {
    const repairs = await this.repairService.getRepairElements(assetId, regionId, referenceDate.toJSON());
    if (!repairs || repairs.length === 0) {
      void this.lightSectionModService.preloadForRegion(assetId, regionId);
      return;
    }

    this.loadAndRenderRepair(repairs);
    void this.lightSectionModService.preloadForRegion(assetId, regionId);
  }

  /**
   * Loads region repairs and controls their visibility based on timeline.
   * Repairs are rendered but only shown if their creation date is before or equal to the reference date.
   */
  public async loadRegionRepairsWithVisibilityControl(assetId: string, regionId: string, referenceDate: Date) {
    const repairs = await this.repairService.getRepairElements(assetId, regionId, referenceDate.toJSON());
    if (!repairs || repairs.length === 0) {
      void this.lightSectionModService.preloadForRegion(assetId, regionId);
      return;
    }

    this.loadAndRenderRepair(repairs);
    void this.lightSectionModService.preloadForRegion(assetId, regionId);

    this.assetManager.asset.RepairCampaigns.forEach((repairCampaign) => {
      repairCampaign.Elements.forEach((repairStructureElement) => {
        if (repairStructureElement.properties) {
          const rawVisDate = new Date(repairStructureElement.properties.General.Collection.Date);
          let formattedDate = new Date(Date.UTC(rawVisDate.getUTCFullYear(), rawVisDate.getUTCMonth(), rawVisDate.getUTCDate()));
          const rdVis = this.assetManager.referenceDate;
          const refDateUTC = new Date(Date.UTC(rdVis.getFullYear(), rdVis.getMonth(), rdVis.getDate()));
          if (this.assetManager.currentRegion.Guid === repairStructureElement.regionId) {
            if (
              formattedDate <= refDateUTC
            ) {
              repairStructureElement.SurfaceDesign.visible = true
            } else {
              repairStructureElement.SurfaceDesign.visible = false
            }
          }
        }
      })
    })
  }

  /** Matches server ordering: Date, then CreatedAtUtc ?? Date, then Id (ascending = oldest first). */
  private compareElementDiffChronologicalAsc(
    a: { Date?: Date | string; CreatedAtUtc?: string; createdAtUtc?: string; Id?: string; id?: string },
    b: { Date?: Date | string; CreatedAtUtc?: string; createdAtUtc?: string; Id?: string; id?: string }
  ): number {
    const dateA = a.Date != null ? new Date(a.Date as Date).getTime() : 0;
    const dateB = b.Date != null ? new Date(b.Date as Date).getTime() : 0;
    if (dateA !== dateB) return dateA - dateB;
    const rawCA = a.CreatedAtUtc ?? a.createdAtUtc;
    const rawCB = b.CreatedAtUtc ?? b.createdAtUtc;
    const createdA = rawCA != null ? new Date(rawCA).getTime() : dateA;
    const createdB = rawCB != null ? new Date(rawCB).getTime() : dateB;
    if (createdA !== createdB) return createdA - createdB;
    const idA = (a.Id ?? a.id ?? '') as string;
    const idB = (b.Id ?? b.id ?? '') as string;
    return idA.localeCompare(idB);
  }

  /**
   * Resolves the geometry to display for a repair: if a diff targets this repair (repair-on-repair cut),
   * returns the latest cut geometry from manager.ElementsViewModelDiff; otherwise returns the repair's stored geometry.
   */
  private getEffectiveGeometryForRepair(manager: { ElementsViewModelDiff?: Array<{ ElementId: string; Date?: Date; CreatedAtUtc?: string; createdAtUtc?: string; NewGeometry3D?: GeometryModel; Id?: string; id?: string }> }, repair: { Element: { ElementId: string; Geometries3D?: Array<GeometryModel> } }): GeometryModel | undefined {
    const fallback = repair.Element.Geometries3D?.[0];
    if (!manager.ElementsViewModelDiff || manager.ElementsViewModelDiff.length === 0)
      return fallback;
    const repairId = repair.Element.ElementId;
    const repairIdNorm = repairId.replace(/-/g, '');
    const diffsForRepair = manager.ElementsViewModelDiff.filter(
      d => d.ElementId === repairId || d.ElementId.replace(/-/g, '') === repairIdNorm
    );
    if (diffsForRepair.length === 0)
      return fallback;
    const latestDiff = [...diffsForRepair].sort(
      (a, b) => -this.compareElementDiffChronologicalAsc(a, b)
    )[0];
    if (latestDiff?.NewGeometry3D?.GeometryV)
      return latestDiff.NewGeometry3D;
    return fallback;
  }

  public loadAndRenderRepair(managers, modifiedRepairId?: string) {
    if (Util.isNullOrUndefined(this._currentRepairCampaign)) {
      this.addNewRepairCollection(new Date(), null, null, null);
    }
    if (managers) {
      for (const manager of managers) {
        if (manager.ElementsViewModelDiff) {
          const sortedDiffs = [...manager.ElementsViewModelDiff].sort((a, b) =>
            this.compareElementDiffChronologicalAsc(a, b)
          );
          for (const targetDiff of sortedDiffs) {
            const _ntarget = this.assetManager.asset.getStructureAndRepairsElements(false).find(x => x.Guid === targetDiff.ElementId || x.Guid === targetDiff.ElementId.replace(/-/g, ''));
            if(!_ntarget) continue;

            const structuralElement = _ntarget as StructuralElement;

            // Check if this is a restore-to-original operation (all cuts deleted)
            if (targetDiff.IsRestoreToOriginal) {
              // Dispose current geometry before replacing
              const currentGeometry = _ntarget.SurfaceDesign.geometry as THREE.BufferGeometry;

              // Restore from the stored original geometry, or fallback to OldGeometry3D from the diff
              if (structuralElement.originalGeometry) {
                _ntarget.SurfaceDesign.geometry = structuralElement.originalGeometry.clone();
                _ntarget.SurfaceDesign.name = _ntarget.Guid;
                // Dispose the stored original geometry
                structuralElement.originalGeometry.dispose();
              } else if (targetDiff.OldGeometry3D?.GeometryV) {
                // Fallback: use OldGeometry3D from the diff when originalGeometry is not available
                let restoredGeometry = new THREE.BufferGeometry();
                restoredGeometry.setAttribute('position', new THREE.BufferAttribute(new Float32Array(targetDiff.OldGeometry3D.GeometryV), 3));
                if (targetDiff.OldGeometry3D.GeometryF && targetDiff.OldGeometry3D.GeometryF.length > 0) {
                  restoredGeometry.setIndex(targetDiff.OldGeometry3D.GeometryF);
                }
                restoredGeometry.computeVertexNormals();
                restoredGeometry = mergeVertices(restoredGeometry);
                restoredGeometry.computeBoundingBox();
                _ntarget.SurfaceDesign.geometry = restoredGeometry;
                _ntarget.SurfaceDesign.name = _ntarget.Guid;
              }

              // Dispose the old current geometry after replacement
              if (currentGeometry) {
                currentGeometry.dispose();
              }

              // Clear the Geometries array and original geometry since all cuts are removed
              structuralElement.Geometries = [];
              structuralElement.originalGeometry = null;

              // Recompute border after restoring original geometry
              structuralElement.clearBorder();
              structuralElement.createBorder(GraphicsMaterials.borderMaterialLineBasic);
            } else {
              // Normal cut diff - store original geometry before first cut
              if (!structuralElement.originalGeometry) {
                // Clone and store the current geometry as original before applying any cuts
                structuralElement.originalGeometry = _ntarget.SurfaceDesign.geometry.clone() as THREE.BufferGeometry;
              }

              // Create new geometry from diff data
              let targetGeometry = new THREE.BufferGeometry();
              if (!targetDiff.NewGeometry3D?.GeometryV) {
                console.warn(`Skipping diff ${targetDiff.id}: NewGeometry3D.GeometryV is missing`);
                continue; // Changed from return to continue - don't abort processing of remaining diffs
              }
              targetGeometry.setAttribute('position', new THREE.BufferAttribute(new Float32Array(targetDiff.NewGeometry3D.GeometryV), 3));
              if (targetDiff.NewGeometry3D.GeometryF && targetDiff.NewGeometry3D.GeometryF.length > 0) targetGeometry.setIndex(targetDiff.NewGeometry3D.GeometryF);
              targetGeometry.computeVertexNormals();

              targetGeometry = mergeVertices(targetGeometry);

              targetGeometry.computeBoundingBox();
              targetGeometry.computeVertexNormals();

              // Dispose old geometry before replacing (but not originalGeometry which we keep)
              const oldGeometry = _ntarget.SurfaceDesign.geometry as THREE.BufferGeometry;
              if (oldGeometry && oldGeometry !== structuralElement.originalGeometry) {
                oldGeometry.dispose();
              }

              _ntarget.SurfaceDesign.geometry = targetGeometry;
              _ntarget.SurfaceDesign.name = _ntarget.Guid;

              // Recompute border after applying cut geometry
              structuralElement.clearBorder();
              structuralElement.createBorder(GraphicsMaterials.borderMaterialLineBasic);

              // Add to Geometries array for history tracking
              if (!structuralElement.Geometries)
                structuralElement.Geometries = [];

              let geometryModelNew: GeometryModel;
              let geometryModelOld: GeometryModel;

              geometryModelNew = targetDiff.NewGeometry3D;
              geometryModelOld = targetDiff.OldGeometry3D;

              var index = structuralElement.Geometries.findIndex(x => x.id === targetDiff.id);
              if (index === -1) {
                structuralElement.Geometries.push({ id: targetDiff.id, date: geometryModelNew.Date, geometryModel: geometryModelNew });
                structuralElement.Geometries.push({ id: targetDiff.id, date: geometryModelOld.Date, geometryModel: geometryModelOld });
              }
            }
          }
        }

        if (manager.Repairs) {
          for (const repair of manager.Repairs) {

            const _isAddedRepair = this._currentRepairCampaign.Elements.find(x => x.Guid === repair.Element.ElementId);
            if (_isAddedRepair) {
              // Skip geometry overwrite for repairs that were not modified —
              // only update the specific repair that was upserted to avoid
              // overwriting unchanged repairs with re-serialized blob data.
              if (modifiedRepairId && repair.Element.ElementId !== modifiedRepairId) {
                continue;
              }
              const effectiveGeometry = this.getEffectiveGeometryForRepair(manager, repair);
              if (!effectiveGeometry?.GeometryV) {
                console.warn(`Skipping repair ${repair.Element.ElementId}: GeometryV is missing`);
                continue;
              }
              (_isAddedRepair.SurfaceDesign.geometry as THREE.BufferGeometry).setAttribute('position', new THREE.BufferAttribute(new Float32Array(effectiveGeometry.GeometryV), 3));
              if (effectiveGeometry.GeometryF && effectiveGeometry.GeometryF.length > 0) (_isAddedRepair.SurfaceDesign.geometry as THREE.BufferGeometry).setIndex(effectiveGeometry.GeometryF);
              (_isAddedRepair.SurfaceDesign.geometry as THREE.BufferGeometry).computeVertexNormals();
              (_isAddedRepair.SurfaceDesign.geometry as THREE.BufferGeometry).computeBoundingBox();
              (_isAddedRepair.SurfaceDesign.geometry as THREE.BufferGeometry).computeBoundingSphere();
              _isAddedRepair.clearBorder();
              _isAddedRepair.createBorder(GraphicsMaterials.borderMaterialLineBasic);
              (_isAddedRepair as StructuralElement).isExecuted = repair.Status === true || repair.Status === 'EXECUTED';
              if ((_isAddedRepair as StructuralElement).isExecuted) {
                if (_isAddedRepair instanceof SurfaceElement) {
                  _isAddedRepair.currentRenderMaterial = (_isAddedRepair as StructuralElement).isDoubler
                    ? GraphicsMaterials.doublerExecutedRepairMaterial
                    : GraphicsMaterials.executedRepairMaterial;
                } else {
                  _isAddedRepair.currentRenderMaterial = (_isAddedRepair as StructuralElement).executedMaterial;
                }
              }
            }
            else {
              if (!repair.Element.TargetId) repair.Element.TargetId = repair.Element.TargetIds[0];
              const _target = this.assetManager.asset.getStructureAndRepairsElements(false).find(x => x.Guid === repair.Element.TargetId || x.Guid === repair.Element.TargetId.replace(/-/g, ''));

              if(!_target) continue;
              const effectiveGeometry = this.getEffectiveGeometryForRepair(manager, repair);
              if (!effectiveGeometry?.GeometryV) {
                console.warn(`Skipping repair ${repair.Element.ElementId}: GeometryV is missing`);
                continue; // Changed from return to continue - don't abort processing of remaining repairs
              }
              const geometry = new THREE.BufferGeometry();
              geometry.setAttribute('position', new THREE.BufferAttribute(new Float32Array(effectiveGeometry.GeometryV), 3));
              if (effectiveGeometry.GeometryF && effectiveGeometry.GeometryF.length > 0) geometry.setIndex(effectiveGeometry.GeometryF);
              geometry.computeVertexNormals();

              let material: THREE.Material = null;
              if (repair.Status === 'OUTLINED')
                material = GraphicsMaterials.hatchingMaterial;
              else
                material = GraphicsMaterials.basicMaterial;

              const _mesh = new THREE.Mesh(geometry, material);
              // repair.Element.TypeId = ELEMENTSTYPESIDS.PLATE;
              let repairStructure: StructuralElement = null;
              switch (repair.Element.TypeId) {
                case ELEMENTSTYPESIDS.PLATE:
                  repairStructure = new SurfaceElement(_mesh, GraphicsMaterials.hatchingMaterial, repair.Element.ElementId);
                  repairStructure.SurfaceDesign = _mesh;
                  if (repair.Status === 'OUTLINED') {
                    repairStructure.defaultMaterial = GraphicsMaterials.hatchingMaterial;
                    repairStructure.currentMaterial = GraphicsMaterials.hatchingMaterial;
                  } else {
                    repairStructure.defaultMaterial = GraphicsMaterials.basicMaterial;
                    repairStructure.currentMaterial = GraphicsMaterials.basicMaterial;
                    repairStructure.executedMaterial = GraphicsMaterials.executedRepairMaterial;
                  }

                  break;
                case ELEMENTSTYPESIDS.STIFFENER:
                  repairStructure = new LinearElement(_mesh, GraphicsMaterials.hatchingMaterial, repair.Element.ElementId);
                  repairStructure.SurfaceDesign = _mesh;
                  if (repair.Status === 'OUTLINED') {
                    repairStructure.defaultMaterial = GraphicsMaterials.hatchingMaterial;
                    repairStructure.currentMaterial = GraphicsMaterials.hatchingMaterial;
                  } else {
                    repairStructure.defaultMaterial = GraphicsMaterials.stiffenerMaterial3d;
                    repairStructure.currentMaterial = GraphicsMaterials.stiffenerMaterial3d;
                    repairStructure.executedMaterial = GraphicsMaterials.stiffenerMaterial3d;
                  }
                  break;
                case ELEMENTSTYPESIDS.FACEPLATE:
                  repairStructure = new LinearElement(_mesh, GraphicsMaterials.hatchingMaterial, repair.Element.ElementId);
                  repairStructure.SurfaceDesign = _mesh;
                  if (repair.Status === 'OUTLINED') {
                    repairStructure.defaultMaterial = GraphicsMaterials.hatchingMaterial;
                    repairStructure.currentMaterial = GraphicsMaterials.hatchingMaterial;
                  } else {
                    repairStructure.defaultMaterial = GraphicsMaterials.flangeMaterial3d;
                    repairStructure.currentMaterial = GraphicsMaterials.flangeMaterial3d;
                    repairStructure.executedMaterial = GraphicsMaterials.flangeMaterial3d;
                  }
                  break;
                case ELEMENTSTYPESIDS.BRACKET:
                  repairStructure = new LinearElement(_mesh, GraphicsMaterials.hatchingMaterial, repair.Element.ElementId);
                  repairStructure.SurfaceDesign = _mesh;
                  if (repair.Status === 'OUTLINED') {
                    repairStructure.defaultMaterial = GraphicsMaterials.hatchingMaterial;
                    repairStructure.currentMaterial = GraphicsMaterials.hatchingMaterial;
                  } else {
                    repairStructure.defaultMaterial = GraphicsMaterials.bracketMaterial3d;
                    repairStructure.currentMaterial = GraphicsMaterials.bracketMaterial3d;
                    repairStructure.executedMaterial = GraphicsMaterials.bracketMaterial3d;
                  }
                  break;
                case ELEMENTSTYPESIDS.BEAM:
                  repairStructure = new SurfaceElement(_mesh, GraphicsMaterials.hatchingMaterial, repair.Element.ElementId);
                  repairStructure.SurfaceDesign = _mesh;
                  if (repair.Status === 'OUTLINED') {
                    repairStructure.defaultMaterial = GraphicsMaterials.hatchingMaterial;
                    repairStructure.currentMaterial = GraphicsMaterials.hatchingMaterial;
                  } else {
                    repairStructure.defaultMaterial = GraphicsMaterials.basicMaterial;
                    repairStructure.currentMaterial = GraphicsMaterials.basicMaterial;
                    repairStructure.executedMaterial = GraphicsMaterials.executedRepairMaterial;
                  }
                  break;
                case ELEMENTSTYPESIDS.BEAMPART:
                  repairStructure = new SurfaceElement(_mesh, GraphicsMaterials.hatchingMaterial, repair.Element.ElementId);
                  repairStructure.SurfaceDesign = _mesh;
                  if (repair.Status === 'OUTLINED') {
                    repairStructure.defaultMaterial = GraphicsMaterials.hatchingMaterial;
                    repairStructure.currentMaterial = GraphicsMaterials.hatchingMaterial;
                  } else {
                    repairStructure.defaultMaterial = GraphicsMaterials.basicMaterial;
                    repairStructure.currentMaterial = GraphicsMaterials.basicMaterial;
                    repairStructure.executedMaterial = GraphicsMaterials.executedRepairMaterial;
                  }
                  break;
                case ELEMENTSTYPESIDS.CABLE:
                  repairStructure = new SurfaceElement(_mesh, GraphicsMaterials.hatchingMaterial, repair.Element.ElementId);
                  repairStructure.SurfaceDesign = _mesh;
                  if (repair.Status === 'OUTLINED') {
                    repairStructure.defaultMaterial = GraphicsMaterials.hatchingMaterial;
                    repairStructure.currentMaterial = GraphicsMaterials.hatchingMaterial;
                  } else {
                    repairStructure.defaultMaterial = GraphicsMaterials.basicMaterial;
                    repairStructure.currentMaterial = GraphicsMaterials.basicMaterial;
                    repairStructure.executedMaterial = GraphicsMaterials.executedRepairMaterial;
                  }
                  break;
                default:
                  break;
              }

              const rawDate = new Date(repair.ElementProperties.General.Collection.Date);
              repairStructure.date = new Date(Date.UTC(rawDate.getUTCFullYear(), rawDate.getUTCMonth(), rawDate.getUTCDate()));
              repair.ElementProperties.General.Collection.Date = repairStructure.date;
              repairStructure.Guid = repair.Element.ElementId;
              const geo = repair.ElementProperties.Geometry;
              (repairStructure as StructuralElement).thickness =
                  geo?.WebBaselineThickness > 0 ? geo.WebBaselineThickness
                  : geo?.WebThickness > 0 ? geo.WebThickness
                  : geo?.FlangeBaselineThickness > 0 ? geo.FlangeBaselineThickness
                  : geo?.FlangeThickness > 0 ? geo.FlangeThickness
                  : geo?.Thickness;
              (repairStructure as StructuralElement).ruleThickness = repair.ElementProperties.Geometry?.RuleThickness;
              _mesh.name = repairStructure.Guid;
              repairStructure.regionId = _target.regionId;
              repairStructure.SectionId = repair.Element.SectionId;
              repairStructure.TypeId = repair.Element.TypeId;
              // repairStructure.sectionNormal = _target.sectionNormal;
              repairStructure.isDoubler = repair.Doubler;
              if (repairStructure.isDoubler) {
                switch (repair.Element.TypeId) {
                  case ELEMENTSTYPESIDS.STIFFENER:
                    repairStructure.executedMaterial = GraphicsMaterials.doublerStiffenerMaterial3d;
                    break;
                  case ELEMENTSTYPESIDS.FACEPLATE:
                    repairStructure.executedMaterial = GraphicsMaterials.doublerFlangeMaterial3d;
                    break;
                  case ELEMENTSTYPESIDS.BRACKET:
                    repairStructure.executedMaterial = GraphicsMaterials.doublerBracketMaterial3d;
                    break;
                  case ELEMENTSTYPESIDS.BEAM:
                    repairStructure.executedMaterial = GraphicsMaterials.doublerBeamMaterial3d;
                    break;
                  default:
                    repairStructure.executedMaterial = GraphicsMaterials.doublerBasicMaterial;
                    break;
                }
              }
              repairStructure.regionIds = repair.Element.RegionIds;
              repairStructure.SurfaceDesign.geometry.computeBoundingBox();
              repairStructure.SurfaceDesign.geometry.computeBoundingSphere();
              repairStructure.SurfaceDesign.geometry.computeVertexNormals();
              repairStructure.SurfaceDesign.userData.scale = 1;
              repairStructure.CreationCommandType = 'RepairElement';
              repairStructure.targetIds = repair.Element.TargetIds;
              repairStructure.targetId = repair.Element.TargetId;
              repairStructure.criticalAreaId = repair.Element.CriticalAreaId;
              // clone.executionStatus = 'OUTLINED';
              repairStructure.outlinedMaterial = GraphicsMaterials.hatchingMaterial;
              repairStructure.createBorder(GraphicsMaterials.borderMaterialLineBasic);
              // repairStructure.inspectionsSolved = _inspections;
              repairStructure.inspectionIds = repair.InspectionsIds;
              repairStructure.isRepair = true;
              repairStructure.isExecuted = repair.Status;
              if (repairStructure.isExecuted) {
                if (repairStructure instanceof SurfaceElement) {
                  repairStructure.currentRenderMaterial = repairStructure.isDoubler
                    ? GraphicsMaterials.doublerExecutedRepairMaterial
                    : GraphicsMaterials.executedRepairMaterial;
                } else {
                  repairStructure.currentRenderMaterial = (repairStructure as StructuralElement).executedMaterial;
                }
              }
              repairStructure.properties = repair.ElementProperties;
              repairStructure.ComputeAttributes();
              repairStructure.setComputedProperties(repairStructure.meanThicknessValue);
              // clone.properties.
              // clone.setComputedProperties(clone.meanThicknessValue);
              switch (repair.Element.TypeId){
                case ELEMENTSTYPESIDS.PLATE:
                case ELEMENTSTYPESIDS.BEAM:
                case ELEMENTSTYPESIDS.BEAMPART:
                case ELEMENTSTYPESIDS.CABLE:
                  this._currentRepairCampaign.addSurfaceElement(repairStructure);

                  break;
                  case ELEMENTSTYPESIDS.STIFFENER:
                  case ELEMENTSTYPESIDS.FACEPLATE:
                  case ELEMENTSTYPESIDS.BRACKET:
                    this._currentRepairCampaign.addLinearElement(repairStructure, _target);

                    break;
                default:
                  break;
              }
              repairStructure.MaterialType = this.assetManager.asset.materials.find(x => x.Guid === repairStructure.properties?.General?.MaterialId);
              repairStructure.ComputeAttributes();
              repairStructure.setComputedProperties(repairStructure.meanThicknessValue);

              repairStructure.section.visible = _target.section.visible;
              repairStructure.properties.General.Doubler = repair.Doubler;

            }
          }
        }
      }
    }
    // this.assetManager.asset.setElementsRepairProperties(repairStructure.RegionId, this.assetManager.asset.elementsProperties);
    // Repair borders (re)created above follow the "show section borders" setting
    // (covers loadRegionRepairs*, upsertRepair, confirmCutPreview and the repair undo/redo commands)
    this.applyRepairBorderSetting();
  }

  /**
   * Applies the "show section borders" setting to the repair element borders
   * (Asset.applyRepairBorderVisibility); renders when a border changed.
   */
  private applyRepairBorderSetting(): void {
    const asset = this.assetManager?.asset;
    if (!asset) return;
    if (asset.applyRepairBorderVisibility() > 0) this.graphics?.requestRender();
  }

  private generateNewCompleteStiffenerRepairLabel(repair: any) {
    var repairs = []
    for (let campain of this.assetManager.asset.RepairCampaigns) {
      repairs = repairs.concat(campain.SurfaceElements)
    }
    for (let campain of this.assetManager.asset.RepairCampaigns) {
      repairs = repairs.concat(campain.LinearElements)
    }

    if (repairs.length > 0) {
      var sameTargetRepairs = repairs.filter(r =>
        r.properties.General.CompleteStiffenerId
        && r.properties.General.CompleteStiffenerId == repair.properties.General.CompleteStiffenerId)

      if (sameTargetRepairs.length > 0) {
        var labelCounters: number[] = []
        for (let existingRepair of sameTargetRepairs) {
          if (existingRepair.properties.General.CompleteStiffenerLabel) {
            const labelArray = (existingRepair.properties.General.CompleteStiffenerLabel as string).split("_")
            const labelCounter = labelArray.pop()
            const counter = parseInt(labelCounter)
            const counterIsNumber = !isNaN(counter)
            if (counterIsNumber) {
              labelCounters.push(counter)
            }
          }
        }
        if (labelCounters.length > 0) {
          var lastCounter = Math.max(...labelCounters)
          lastCounter = lastCounter + 1
          return repair.properties.General.CompleteStiffenerLabel + "_" + lastCounter
        }
      }
    }

    return repair.properties.General.CompleteStiffenerLabel + '_1'
  }

  private generateNewCompleteBracketRepairLabel(repair: any) {
    var repairs = []
    for (let campain of this.assetManager.asset.RepairCampaigns) {
      repairs = repairs.concat(campain.SurfaceElements)
    }
    for (let campain of this.assetManager.asset.RepairCampaigns) {
      repairs = repairs.concat(campain.LinearElements)
    }

    if (repairs.length > 0) {
      var sameTargetRepairs = repairs.filter(r =>
        r.properties.General.CompleteBracketId
        && r.properties.General.CompleteBracketId == repair.properties.General.CompleteBracketId)

      if (sameTargetRepairs.length > 0) {
        var labelCounters: number[] = []
        for (let existingRepair of sameTargetRepairs) {
          if (existingRepair.properties.General.CompleteBracketLabel) {
            const labelArray = (existingRepair.properties.General.CompleteBracketLabel as string).split("_")
            const labelCounter = labelArray.pop()
            const counter = parseInt(labelCounter)
            const counterIsNumber = !isNaN(counter)
            if (counterIsNumber) {
              labelCounters.push(counter)
            }
          }
        }
        if (labelCounters.length > 0) {
          var lastCounter = Math.max(...labelCounters)
          lastCounter = lastCounter + 1
          return repair.properties.General.CompleteBracketLabel + "_" + lastCounter
        }
      }
    }

    return repair.properties.General.CompleteBracketLabel + '_1'
  }
  public isSavingRepair: boolean = false;
  public isCutPreviewing = new BehaviorSubject<boolean>(false);
  public isRepairAreaPreviewing = new BehaviorSubject<boolean>(false);
  private _previewMeshes: THREE.Mesh[] = [];
  private _previewTargets: any[] = [];
  private _previewMeshsPerTarget: THREE.Mesh[] = [];
  private _repairPreviewMeshes: THREE.Mesh[] = [];

  private _lineCutResult: { negativeGeometry: any; positiveGeometry: any } | null = null;
  private _lineCutElement: SurfaceElement | null = null;
  private _isLineCutPreview = false;
  private _hiddenOriginalMesh: THREE.Object3D | null = null;

  public setLineCutPreview(result: { negativeGeometry: any; positiveGeometry: any }, currentElement: SurfaceElement): void {
    if (this._isLineCutPreview) return;

    this._lineCutResult = result;
    this._lineCutElement = currentElement;
    this._isLineCutPreview = true;

    // Hide the original plate mesh to avoid z-fighting
    this._hiddenOriginalMesh = currentElement.SurfaceDesign;
    currentElement.SurfaceDesign.visible = false;

    // Add preview meshes to the same parent group as the plate to preserve transforms
    const parent = currentElement.SurfaceDesign.parent || this.graphics.scene;
    const originalMaterial = (currentElement.SurfaceDesign as THREE.Mesh).material;
    const positiveMesh = new THREE.Mesh(result.positiveGeometry.clone(), originalMaterial);
    const negativeMesh = new THREE.Mesh(result.negativeGeometry.clone(), GraphicsMaterials.cutPreviewMaterial);
    this._previewMeshes.push(positiveMesh, negativeMesh);
    parent.add(positiveMesh);
    parent.add(negativeMesh);

    this.isCutPreviewing.next(true);
  }

  public async confirmCutPreview() {
    if (this._isLineCutPreview) {
      await this.confirmLineCut();
      return;
    }

    if (this._previewMeshes.length === 0 || this._previewTargets.length === 0) return;

    this.isSavingRepair = true;
    try {
      const _mesh = this._previewMeshes[0];

      const rdCut = this.assetManager.referenceDate;
      const cutShape = {
        SurfaceDesign: _mesh,
        regionId: this._previewTargets[0].regionId,
        regionIds: [...new Set(this._previewTargets.map(t => t.regionId))],
        SectionId: this._previewTargets[0].SectionId,
        Guid: uuid() as string,
        targetId: this._previewTargets[0].Guid,
        targetIds: this._previewTargets.map(t => t.Guid),
        date: new Date(Date.UTC(rdCut.getFullYear(), rdCut.getMonth(), rdCut.getDate())),
      };

      const repairManager = await this.repairService.upsertCutPlate(
        cutShape,
        this.assetManager.asset.assetInfo.AssetId,
        this._previewTargets,
        this._previewMeshsPerTarget
      );

      if (repairManager) {
        // Pass cutShape.Guid so unchanged repairs are not overwritten with re-serialized blob data
        this.loadAndRenderRepair([repairManager], cutShape.Guid);
      }

      // Remove and dispose preview meshes from scene
      this.clearCutPreviewMeshes();

      // Clear drawing state for next cut
      this.graphicsRenderRepair.rectd.meshs = [];
      this.graphicsRenderRepair.rectd.targets = [];
      this.graphicsRenderRepair.rectd.meshsPerTarget = [];
    } finally {
      this.isSavingRepair = false;
      this.isCutPreviewing.next(false);
    }
  }

  private async confirmLineCut() {
    if (!this._lineCutResult || !this._lineCutElement) return;

    this.isSavingRepair = true;
    try {
      this.noticationService.addInProgressNotification('Cutting Element');
      this.assetManager.setIsLoading(true);

      const currentElement = this._lineCutElement;
      const result = this._lineCutResult;
      const newId = uuid() as string;
      const oldGeometry = currentElement.SurfaceDesign.geometry as THREE.BufferGeometry;
      const newElement = currentElement
        .cloneWithGeometry(result.negativeGeometry, GraphicsMaterials.basicMaterial, newId);

      this.assetManager.asset.StructureCampaigns[0].addSurfaceElement(newElement);
      result.positiveGeometry.computeBoundingBox();
      result.positiveGeometry.computeBoundingSphere();
      result.positiveGeometry.computeVertexNormals();
      currentElement.SurfaceDesign.geometry = result.positiveGeometry;
      currentElement.SurfaceDesign.name = currentElement.Guid;
      if (oldGeometry && oldGeometry !== result.positiveGeometry) {
        oldGeometry.dispose();
      }

      // Rebuild split borders immediately so the cut line is visible without page reload.
      currentElement.clearBorder();
      currentElement.createBorder(GraphicsMaterials.borderMaterialLineBasic);
      newElement.clearBorder();
      newElement.createBorder(GraphicsMaterials.borderMaterialLineBasic);

      // Force transform and world matrix updates on both resulting meshes.
      currentElement.SurfaceDesign.updateMatrix();
      currentElement.SurfaceDesign.updateMatrixWorld();
      currentElement.SurfaceDesign.updateWorldMatrix(true, true);
      newElement.SurfaceDesign.updateMatrix();
      newElement.SurfaceDesign.updateMatrixWorld();
      newElement.SurfaceDesign.updateWorldMatrix(true, true);

      this.graphics.scene.matrixWorldNeedsUpdate = true;

      const _newWebPoints = Array.from(result.positiveGeometry.attributes.position.array);
      const _newWebIndices = Array.from(result.positiveGeometry.index.array);
      const _newFlangePoints = Array.from(result.negativeGeometry.attributes.position.array);
      const _newFlangeIndices = Array.from(result.negativeGeometry.index.array);

      const newWebPoints = GeometryExtrusionComputer
        .getNonIndexedPositionArray(_newWebPoints, _newWebIndices);
      const newFlangePoints = GeometryExtrusionComputer
        .getNonIndexedPositionArray(_newFlangePoints, _newFlangeIndices);

      const fetchData = await this.digitalTwinService.updateProperties(
        currentElement.properties, this.assetManager.getCurrentRegionId(),
        this.assetManager.asset.assetInfo.AssetId, false, true,
        newWebPoints, newFlangePoints, newElement.properties,
        null, true, null, currentElement.SectionId);
      const response = await firstValueFrom(fetchData);

      this.selectionService.selectElement(
        currentElement.regionId, currentElement.SectionId, currentElement.Guid, false);

      const fetchDataInspec = await this.digitalTwinService.reapplyInspectionsAfterMergeAndCut(
        this.assetManager.asset.assetInfo.AssetId,
        [newElement.properties.ElementId, currentElement.properties.ElementId],
        this.assetManager.referenceDate, currentElement.regionId);
      const responseInspec = await firstValueFrom(fetchDataInspec);

      // Fallback refresh for region overlays (lines/borders) after cut persistence.
      this.selectionService.renderLinesAndBordersForVisibleRegions(this.assetManager.asset);

      this.noticationService.addSuccessNotification('Element cut successfully');
    } finally {
      this.clearCutPreviewMeshes();
      this.clearLineCutPreviewData();
      this.isSavingRepair = false;
      this.isCutPreviewing.next(false);
      this.assetManager.setFunctionalityModeNone();
      this.assetManagerTools.clearTemporaryGeometries();
      this.assetManager.setIsLoading(false);
      this.assetManager.setCutFinished(true);
    }
  }

  public cancelCutPreview() {
    if (this._isLineCutPreview) {
      this.clearCutPreviewMeshes();
      this.clearLineCutPreviewData();
      this.isCutPreviewing.next(false);
      this.assetManager.setFunctionalityModeNone();
      this.assetManagerTools.clearTemporaryGeometries();
      this.assetManager.setCutFinished(true);
      return;
    }

    // Remove and dispose preview meshes from scene
    this.clearCutPreviewMeshes();

    // Clear drawing state so user can redraw
    this.graphicsRenderRepair.rectd.meshs = [];
    this.graphicsRenderRepair.rectd.targets = [];
    this.graphicsRenderRepair.rectd.meshsPerTarget = [];

    this.isCutPreviewing.next(false);
  }

  private clearLineCutPreviewData() {
    if (this._hiddenOriginalMesh) {
      this._hiddenOriginalMesh.visible = true;
      this._hiddenOriginalMesh = null;
    }
    this._lineCutResult = null;
    this._lineCutElement = null;
    this._isLineCutPreview = false;
  }

  private clearCutPreviewMeshes() {
    for (const mesh of this._previewMeshes) {
      if (mesh.parent) {
        mesh.parent.remove(mesh);
      }
      if (mesh.geometry) {
        mesh.geometry.dispose();
      }
    }
    this._previewMeshes = [];
    this._previewTargets = [];
    this._previewMeshsPerTarget = [];
  }

  private clearRepairPreviewMeshes() {
    for (const mesh of this._repairPreviewMeshes) {
      if (mesh.parent) {
        mesh.parent.remove(mesh);
      }
      if (mesh.geometry) {
        mesh.geometry.dispose();
      }
    }
    this._repairPreviewMeshes = [];
  }

  public async confirmRepairPreview() {
    if (!this.isRepairAreaPreviewing.value) return;
    if (Util.isNullOrUndefined(this.graphicsRenderRepair.rectd.meshs) || this.graphicsRenderRepair.rectd.meshs.length === 0) {
      this.clearRepairPreviewMeshes();
      this.isRepairAreaPreviewing.next(false);
      return;
    }
    this.assetManager.setIsLoading(true);
    try {
      if (Util.isNullOrUndefined(this._currentRepairCampaign)) {
        this.addNewRepairCollection(new Date(), null, null, null);
      }
      await this.persistRepairAreaFromRectd();
      this.clearRepairPreviewMeshes();
      this.graphicsRenderRepair.rectd.meshs = [];
      this.graphicsRenderRepair.rectd.targets = [];
      if (this.graphicsRenderRepair.rectd.meshsPerTarget) {
        this.graphicsRenderRepair.rectd.meshsPerTarget = [];
      }
    } finally {
      this.isSavingRepair = false;
      this.assetManager.setIsLoading(false);
      this.isRepairAreaPreviewing.next(false);
      // persistRepairAreaFromRectd's createBorder runs outside loadAndRenderRepair when upsertRepair failed or was skipped
      this.applyRepairBorderSetting();
    }
  }

  public cancelRepairPreview() {
    this.clearRepairPreviewMeshes();
    this.graphicsRenderRepair.rectd.meshs = [];
    this.graphicsRenderRepair.rectd.targets = [];
    if (this.graphicsRenderRepair.rectd.meshsPerTarget) {
      this.graphicsRenderRepair.rectd.meshsPerTarget = [];
    }
    this.isRepairAreaPreviewing.next(false);
  }

  /**
   * Persists the current repair area (rectd) to campaign and backend.
   * Used after user confirms the repair area preview in MANUALREPAIR / SPLITMANUALREPAIR.
   */
  private async persistRepairAreaFromRectd(): Promise<void> {
    if (Util.isNullOrUndefined(this.graphicsRenderRepair.rectd.meshs)) return;
    const rectd = this.graphicsRenderRepair.rectd;
    if (this.elementTypeForInsertionAndSelectionGuid === ELEMENTSTYPESIDS.STIFFENER ||
        this.elementTypeForInsertionAndSelectionGuid === ELEMENTSTYPESIDS.BRACKET ||
        this.elementTypeForInsertionAndSelectionGuid === ELEMENTSTYPESIDS.FACEPLATE) {
      let elementsList: Array<{ mesh: any; target: LinearElement }> = [];
      for (let i = 0; i < rectd.meshs.length; i++) {
        const _mesh = rectd.meshs[i];
        if (_mesh?.geometry instanceof BufferGeometry) {
          _mesh.geometry = mergeVertices(_mesh.geometry as BufferGeometry);
        }
        const target = rectd.targets[i];
        const _target = this.assetManager.asset.getStructureAndRepairsElements(false).find(x => x.Guid === target.name);
        if (_target) {
          elementsList.push({ mesh: _mesh, target: _target as LinearElement });
        }
      }
      const groupedByMaterialAndThickness: Array<Array<{ mesh: any; target: LinearElement }>> = [];
      for (const element of elementsList) {
        const index = groupedByMaterialAndThickness.findIndex(x =>
          x.findIndex(y => y.target.MaterialType.Guid === element.target.MaterialType.Guid &&
            y.target.thickness === element.target.thickness && y.target.isFlange === element.target.isFlange) > -1);
        if (index > -1) {
          groupedByMaterialAndThickness[index].push(element);
        } else {
          groupedByMaterialAndThickness.push([element]);
        }
      }
      if (rectd.isCut) {
        for (const targetCut of groupedByMaterialAndThickness) {
          const targets = [];
          const geometries = [];
          for (const item of targetCut) {
            targets.push(item.target);
            geometries.push(item.mesh.geometry);
          }
          const mergedGeometry = mergeGeometries(geometries);
          const Id = uuid() as string;
          const clone = targets[0].clone() as LinearElement;
          clone.SurfaceDesign = new THREE.Mesh(mergedGeometry, GraphicsMaterials.hatchingMaterial);
          clone.defaultMaterial = GraphicsMaterials.hatchingMaterial;
          clone.currentMaterial = GraphicsMaterials.hatchingMaterial;
          clone.outlinedMaterial = GraphicsMaterials.hatchingMaterial;
          clone.Guid = Id;
          clone.SurfaceDesign.name = Id;
          clone.SurfaceDesign.geometry.computeBoundingBox();
          clone.SurfaceDesign.geometry.computeBoundingSphere();
          clone.SurfaceDesign.geometry.computeVertexNormals();
          clone.SurfaceDesign.userData.scale = 1;
          clone.CreationCommandType = 'RepairElement';
          clone.targetIds = targets.map(x => x.Guid);
          clone.isRepair = true;
          clone.isDoubler = false;
          clone.targetId = targets[0].name;
          const rdLin = this.assetManager.referenceDate;
          clone.date = new Date(Date.UTC(rdLin.getFullYear(), rdLin.getMonth(), rdLin.getDate()));
          const inspections = rectd.inspections.filter(x =>
            clone.targetIds.includes(x.elementResult.TargetGeometryId) ||
            clone.targetIds.includes(x.elementResult.TargetGeometryId.replace(/-/g, '') as string));
          clone.inspectionsSolved = inspections;
          clone.executionStatus = 'OUTLINED';
          clone.isExecuted = false;
          clone.properties.ElementId = clone.Guid;
          switch (clone.TypeId) {
            case ELEMENTSTYPESIDS.STIFFENER:
              clone.executedMaterial = GraphicsMaterials.stiffenerMaterial3d;
              break;
            case ELEMENTSTYPESIDS.FACEPLATE:
              clone.executedMaterial = GraphicsMaterials.flangeMaterial3d;
              break;
            case ELEMENTSTYPESIDS.BRACKET:
              clone.executedMaterial = GraphicsMaterials.bracketMaterial3d;
              break;
            default:
              break;
          }
          if (clone.properties.General.CompleteStiffenerLabel) {
            clone.properties.General.CompleteStiffenerLabel = this.generateNewCompleteStiffenerRepairLabel(clone);
          }
          if (clone.properties.General.CompleteBracketLabel) {
            clone.properties.General.CompleteBracketLabel = this.generateNewCompleteBracketRepairLabel(clone);
          }
          clone.properties.General.Label = this.generateNewRepairLabel(clone);
          clone.properties.General.Collection = {
            Date: clone.date,
            Id: uuid() as string,
            Name: 'Repair Collection',
            Report: 'Repair'
          };
          clone.createBorder(GraphicsMaterials.borderMaterialLineBasic);
          clone.MaterialType = this.assetManager.asset.materials.find(x => x.Guid === clone.properties?.General?.MaterialId);
          clone.ComputeAttributes();
          clone.setComputedProperties(clone.meanThicknessValue);
          this._currentRepairCampaign.addLinearElement(clone, targets[0]);
          await this.upsertRepair(clone);
        }
      } else {
        for (const targetDoubler of groupedByMaterialAndThickness) {
          const targets = [];
          const geometries = [];
          for (const item of targetDoubler) {
            targets.push(item.target);
            geometries.push(item.mesh.geometry);
          }
          const mergedGeometry = mergeGeometries(geometries);
          const Id = uuid() as string;
          const clone = targets[0].clone() as LinearElement;
          clone.SurfaceDesign = new THREE.Mesh(mergedGeometry, GraphicsMaterials.hatchingMaterial);
          clone.defaultMaterial = GraphicsMaterials.hatchingMaterial;
          clone.currentMaterial = GraphicsMaterials.hatchingMaterial;
          clone.outlinedMaterial = GraphicsMaterials.hatchingMaterial;
          clone.Guid = Id;
          clone.SurfaceDesign.name = Id;
          clone.SurfaceDesign.geometry.computeBoundingBox();
          clone.SurfaceDesign.geometry.computeBoundingSphere();
          clone.SurfaceDesign.geometry.computeVertexNormals();
          clone.SurfaceDesign.userData.scale = 1;
          clone.CreationCommandType = 'RepairElement';
          clone.targetIds = targets.map(x => x.Guid);
          clone.isRepair = true;
          clone.isDoubler = true;
          clone.targetId = targets[0].name;
          const rdLin = this.assetManager.referenceDate;
          clone.date = new Date(Date.UTC(rdLin.getFullYear(), rdLin.getMonth(), rdLin.getDate()));
          const inspections = rectd.inspections.filter(x =>
            clone.targetIds.includes(x.elementResult.TargetGeometryId) ||
            clone.targetIds.includes(x.elementResult.TargetGeometryId.replace(/-/g, '') as string));
          clone.inspectionsSolved = inspections;
          clone.executionStatus = 'OUTLINED';
          clone.isExecuted = false;
          clone.properties.ElementId = clone.Guid;
          switch (clone.TypeId) {
            case ELEMENTSTYPESIDS.STIFFENER:
              clone.executedMaterial = GraphicsMaterials.stiffenerMaterial3d;
              break;
            case ELEMENTSTYPESIDS.FACEPLATE:
              clone.executedMaterial = GraphicsMaterials.flangeMaterial3d;
              break;
            case ELEMENTSTYPESIDS.BRACKET:
              clone.executedMaterial = GraphicsMaterials.bracketMaterial3d;
              break;
            default:
              break;
          }
          if (clone.properties.General.CompleteStiffenerLabel) {
            clone.properties.General.CompleteStiffenerLabel = this.generateNewCompleteStiffenerRepairLabel(clone);
          }
          if (clone.properties.General.CompleteBracketLabel) {
            clone.properties.General.CompleteBracketLabel = this.generateNewCompleteBracketRepairLabel(clone);
          }
          clone.properties.General.Label = this.generateNewRepairLabel(clone);
          clone.properties.General.Collection = {
            Date: clone.date,
            Id: uuid() as string,
            Name: 'Repair Collection',
            Report: 'Repair'
          };
          clone.createBorder(GraphicsMaterials.borderMaterialLineBasic);
          clone.MaterialType = this.assetManager.asset.materials.find(x => x.Guid === clone.properties?.General?.MaterialId);
          clone.ComputeAttributes();
          clone.setComputedProperties(clone.meanThicknessValue);
          this._currentRepairCampaign.addLinearElement(clone, targets[0]);
          await this.upsertRepair(clone);
        }
      }
    } else {
      for (let i = 0; i < rectd.meshsPerTarget.length; i++) {
        const _mesh = rectd.meshsPerTarget[i];
        if (_mesh?.geometry instanceof BufferGeometry) {
          _mesh.geometry = mergeVertices(_mesh.geometry as BufferGeometry);
        }
      }
      for (let i = 0; i < rectd.meshs.length; i++) {
        const _mesh = rectd.meshs[i];
        if (_mesh?.geometry instanceof BufferGeometry) {
          _mesh.geometry = mergeVertices(_mesh.geometry as BufferGeometry);
        }
        const target = rectd.targets[i];
        const _target = this.assetManager.asset.getStructureAndRepairsElements(false).find(x => x.Guid === target.name);
        if (_target && _target instanceof SurfaceElement) {
          const targets: string[] = [];
          for (const targetCut of rectd.targets) {
            const _targetMeshSurface = this.assetManager.asset.getStructureAndRepairsElements(false).find(x => x.Guid === targetCut.name);
            if (!_targetMeshSurface) continue;
            targets.push(_targetMeshSurface.Guid);
          }
          const Id = uuid() as string;
          const clone = _target.clone(this.getRepairCounter(target.name)) as SurfaceElement;
          clone.SurfaceDesign = _mesh;
          clone.defaultMaterial = GraphicsMaterials.hatchingMaterial;
          clone.currentMaterial = GraphicsMaterials.hatchingMaterial;
          clone.outlinedMaterial = GraphicsMaterials.hatchingMaterial;
          clone.Guid = Id;
          clone.SurfaceDesign.name = Id;
          clone.SurfaceDesign.geometry.computeBoundingBox();
          clone.SurfaceDesign.geometry.computeBoundingSphere();
          clone.SurfaceDesign.geometry.computeVertexNormals();
          clone.SurfaceDesign.userData.scale = 1;
          clone.CreationCommandType = 'RepairElement';
          // Divided Cut: each repair part must target only its own plate.
          // Undivided (or non-cut) keeps existing multi-target scope.
          if (rectd.isCut && this.functionalityMode === 'SPLITMANUALREPAIR') {
            clone.targetIds = [target.name];
          } else {
            clone.targetIds = targets;
          }
          // clone.executedMaterial = GraphicsMaterials.executedRepairMaterial;
          clone.createBorder(GraphicsMaterials.borderMaterialLineBasic);
          const filteredInspections = rectd.inspections.filter(x =>
            clone.targetIds.includes(x.elementResult.TargetGeometryId) ||
            clone.targetIds.includes(x.elementResult.TargetGeometryId.replace(/-/g, '') as string)
          );
          clone.inspectionsSolved = filteredInspections;
          clone.executionStatus = 'OUTLINED';
          clone.isExecuted = false;
          clone.isRepair = true;
          clone.targetId = target.name;
          clone.properties.ElementId = clone.Guid;
          const rdSurf = this.assetManager.referenceDate;
          clone.date = new Date(Date.UTC(rdSurf.getFullYear(), rdSurf.getMonth(), rdSurf.getDate()));
          if (rectd.isCut) {
            clone.isDoubler = false;
            clone.executedMaterial = GraphicsMaterials.executedRepairMaterial;
          } else {
            clone.isDoubler = true;
            clone.executedMaterial = GraphicsMaterials.doublerBasicMaterial;
          }
          clone.properties.General.Collection = {
            Date: clone.date,
            Id: uuid().replace(/-/g, '') as string,
            Name: 'Repair Collection',
            Report: 'Repair'
          };
          clone.MaterialType = this.assetManager.asset.materials.find(x => x.Guid === clone.properties?.General?.MaterialId);
          clone.ComputeAttributes();
          clone.setComputedProperties(clone.meanThicknessValue);
          this._currentRepairCampaign.addSurfaceElement(clone);
          const geometryMeshesForUpsert =
            (rectd.isCut && this.functionalityMode === 'SPLITMANUALREPAIR')
              ? (rectd.meshsPerTarget?.[i] ? [rectd.meshsPerTarget[i]] : rectd.meshsPerTarget)
              : rectd.meshsPerTarget;
          await this.upsertRepair(clone, geometryMeshesForUpsert);
        }
      }
    }
  }

  private formatGuidWithHyphens(guid: string): string {
    const cleanGuid = guid.replace(/-/g, '');
    return [
      cleanGuid.slice(0, 8),
      cleanGuid.slice(8, 12),
      cleanGuid.slice(12, 16),
      cleanGuid.slice(16, 20),
      cleanGuid.slice(20)
    ].join('-');
  }

  public async upsertRepair(repair: any, geometryMeshes: THREE.Mesh[] = null) {
    if (!this.isSavingRepair) {
      this.isSavingRepair = true;
      // this.commandManager.lock();
      try {
        let targets = [];
        for (const targetId of repair.targetIds) {
          const targetIdWithHyphens = this.formatGuidWithHyphens(targetId);
          const targetIdWithoutHyphens = targetId.replace(/-/g, '');

          const _targetMeshSurface = this.assetManager.asset.getStructureAndRepairsElements(false).find(x =>
            x.Guid === targetIdWithHyphens || x.Guid === targetIdWithoutHyphens
          );
          if (_targetMeshSurface) {
            targets.push(_targetMeshSurface);
          }
        }

        const repairManager = await this.repairService.upsertRepair(repair, this.assetManager.asset.assetInfo.AssetId, targets, geometryMeshes);

        // The repair gets its Action Plan (and Plan Item) before its execution is recorded,
        // so a repair drawn as executed has an item to execute. Best effort, as legacy: a
        // refused plan does not fail the repair save.
        var assetActions = await firstValueFrom(this.actionsService.getActions(this.assetManager.asset.assetInfo.AssetId));
        var repairActionTypeId = repair.isDoubler ? ELEMENTSTYPESIDS.REPAIRDOUBLER : ELEMENTSTYPESIDS.REPAIR;
        var repairAction = assetActions.find(x => x.TypeId == repairActionTypeId);
        if (repairAction) {
          try {
            await this.inspectionPlanService.createActionPlanForRepair(repair.Guid, repairAction.Id,
              new Date(repair.date),
              this.assetManager.asset.assetInfo.AssetId, repair.regionId, repair.SectionId);
          } catch (error) {
            console.warn('The repair was saved without a plan', error);
          }
        }

        // The repair's Plan Item follows its executed flag in ThreeD.
        const planWork = { assetId: this.assetManager.asset.assetInfo.AssetId, repairIds: [repair.Guid] };
        if (repair.isExecuted) {
          void this.planExecutionService.recordExecuted(planWork, repair.date);
        } else {
          void this.planExecutionService.withdrawExecuted(planWork);
        }

        if (repair.isExecuted) {
          // var criticalAreaTosolve = this.assetManager.asset.CriticalAreaCampaigns[0]?.Elements.find(x => (x as CriticalAreaElement).CriticalAreaProperties.CriticalAreaId === repair.criticalAreaId)
          // if (criticalAreaTosolve) {
          //   (criticalAreaTosolve as CriticalAreaElement).CriticalAreaProperties.DateEnded = new Date(repair.properties.General.Collection.Date);

          //   await this.assetManagerCriticalArea.saveCriticalArea((criticalAreaTosolve as CriticalAreaElement).CriticalAreaProperties);
          // }
          var inspectionsIds = await this.repairService.solveInspection(repair, this.assetManager.asset.assetInfo.AssetId, targets);

          for (const inspectionCollection of this.assetManager.asset.InspectionCampaigns) {
            let inspections = inspectionCollection.Elements.filter(x => inspectionsIds.includes(x.Guid));
            for (const inspection of inspections) {
              (inspection as GaugingElement).active = false;

              (inspection as GaugingElement).elementResult.EndDate = repair.date
            }
          }

          await this.assetManager.estimateDegradationByCurveParameters();

        }
        else{
          var inspectionsIds = await this.repairService.reActivateRepairInspections(repair, this.assetManager.asset.assetInfo.AssetId, targets);
          for (const inspectionCollection of this.assetManager.asset.InspectionCampaigns) {
            let inspections = inspectionCollection.Elements.filter(x => inspectionsIds.includes(x.Guid));
            for (const inspection of inspections) {
              (inspection as GaugingElement).active = true;

              (inspection as GaugingElement).elementResult.EndDate = new Date(1,1,1,1,1,1,1)
            }
          }
        }

        if (!this.assetManager.asset.repairsList || this.assetManager.asset.repairsList.length == 0) {
          await this.assetManager.loadRepairsToTimeline();
        }
        // Always call loadAndRenderRepair to update geometry and borders for all cut modes (single line, merge, shape)
        // Pass the modified repair ID so unchanged repairs are not overwritten
        this.loadAndRenderRepair([repairManager], repair.Guid);
        this.noticationService.addFinishedNotification('Saving Repair');
      } catch (error) {
        console.error('Error during repair upsert:', error);
        this.noticationService.addFinishedNotification('Error saving repair');
        this.snackBar.open('Error saving repair', '', {
          horizontalPosition: 'right',
          verticalPosition: 'bottom',
          duration: 3000
        });
      } finally {
        this.isSavingRepair = false;
        // this.commandManager.unlock();
      }
    } else {
      this.snackBar.open('Please Wait while we finish saving the repair', '', {
        horizontalPosition: 'right',
        verticalPosition: 'bottom',
        duration: 3000
      });
    }
  }

  public async deleteRepair(repair: any) {
    // Capture state BEFORE deletion
    // const capturedState = this.repairCommandService.captureState(repair);

    // this.commandManager.lock();
    try {
      await this.repairService.deleteRepair(repair, this.assetManager.asset.assetInfo.AssetId).then(async ()  => {
        this.clusterService.RegenerateClustersIfNeededWhenDeleted({ ClusterType: "Structure", AssetId: this.assetManager.asset.assetInfo.AssetId, RegionIds: repair.regionIds, Dates: [repair.date] }).toPromise();

        let targets = [];
        for (const targetId of repair.targetIds) {
          const _targetMeshSurface = this.assetManager.asset.getStructureElements(false).find(x => x.Guid === targetId);
          targets.push(_targetMeshSurface);
        }
        for (const targetId of repair.targetIds) {
          const _targetMeshSurface = this.assetManager.asset.getStructureElements(false).find(x => x.Guid === targetId);

          const rawDelDate = new Date(repair.properties.General.Collection.Date);
          let formattedDate = new Date(Date.UTC(rawDelDate.getUTCFullYear(), rawDelDate.getUTCMonth(), rawDelDate.getUTCDate()));

          for (let i = (_targetMeshSurface as StructuralElement)?.Geometries?.length - 1; i >= 0; i--) {
            const geometry = (_targetMeshSurface as StructuralElement).Geometries[i];
            let d = new Date(geometry.date);
            d = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()));
            if (d.getTime() === formattedDate.getTime()) {
              (_targetMeshSurface as StructuralElement).Geometries.splice(i, 1);
              // break;
            }
          }
        }
        this.assetManager.ChangeReferenceDate(this.assetManager.referenceDate);
        if(repair.properties.TypeId == ELEMENTSTYPESIDS.PLATE)
          (repair as StructuralElement).Campaign.deleteElementByIdOnly((repair as StructuralElement).regionId, (repair as StructuralElement).Guid);
        else{
          (repair as LinearElement).Campaign.deleteElementLinearElementByIdOnly((repair as LinearElement).regionId, (repair as LinearElement).Guid);
        }

        var inspectionsIds = await this.repairService.reActivateRepairInspections(repair, this.assetManager.asset.assetInfo.AssetId, targets);
        for (const inspectionCollection of this.assetManager.asset.InspectionCampaigns) {
          let inspections = inspectionCollection.Elements.filter(x => inspectionsIds.includes(x.Guid));
          for (const inspection of inspections) {
            (inspection as GaugingElement).active = true;

            (inspection as GaugingElement).elementResult.EndDate = new Date(1,1,1,1,1,1,1)
          }
        }
        // for (const iterator of object) {

        // }

        // Register for undo AFTER successful deletion
        // this.repairCommandService.registerDeleteCommand(capturedState);

        this.noticationService.addFinishedNotification('Saving Repair')

        // this.snackBar.open('Finished saving repair', '', {
        //   horizontalPosition: 'right',
        //   verticalPosition: 'bottom',
        //   duration: 3000
        // });
      });
    } finally {
      // this.commandManager.unlock();
    }
  }

  private generateNewRepairLabel(repair: any): string {
    var repairs = []
    for (let campain of this.assetManager.asset.RepairCampaigns) {
      repairs = repairs.concat(campain.SurfaceElements)
    }
    for (let campain of this.assetManager.asset.RepairCampaigns) {
      repairs = repairs.concat(campain.LinearElements)
    }

    if (repairs.length > 0) {
      var sameTargetRepairs = repairs.filter(r => r.targetId == repair.targetId)

      if (sameTargetRepairs.length > 0) {
        var labelCounters: number[] = []
        for (let existingRepair of sameTargetRepairs) {
          if (existingRepair.properties.General.Label) {
            const labelArray = (existingRepair.properties.General.Label as string).split("_")
            const labelCounter = labelArray.pop()
            const counter = parseInt(labelCounter)
            const counterIsNumber = !isNaN(counter)
            if (counterIsNumber) {
              labelCounters.push(counter)
            }
          }
        }
        if (labelCounters.length > 0) {
          var lastCounter = Math.max(...labelCounters)
          lastCounter = lastCounter + 1
          return repair.properties.General.Label + "_" + lastCounter
        }
      }
    }

    return repair.properties.General.Label + '_1'
  }

  private getRepairCounter(targetId:string): number {
    var repairs = []
    for (let campain of this.assetManager.asset.RepairCampaigns) {
      repairs = repairs.concat(campain.SurfaceElements)
    }
    for (let campain of this.assetManager.asset.RepairCampaigns) {
      repairs = repairs.concat(campain.LinearElements)
    }

    if (repairs.length > 0) {
      var sameTargetRepairs = repairs.filter(r => r.targetId == targetId)

      if (sameTargetRepairs.length > 0) {
        var labelCounters: number[] = []
        for (let existingRepair of sameTargetRepairs) {
          if (existingRepair.properties.General.Label) {
            const labelArray = (existingRepair.properties.General.Label as string).split("_")
            const labelCounter = labelArray.pop()
            const counter = parseInt(labelCounter)
            const counterIsNumber = !isNaN(counter)
            if (counterIsNumber) {
              labelCounters.push(counter)
            }
          }
        }
        if (labelCounters.length > 0) {
          var lastCounter = Math.max(...labelCounters)
          return lastCounter + 1
        }
      }
    }

    return 1
  }

  private isOnLinearElement(elementTypeId: string): boolean {
    switch (elementTypeId) {
      case ELEMENTSTYPESIDS.STIFFENER:
      case ELEMENTSTYPESIDS.FACEPLATE:
      case ELEMENTSTYPESIDS.BRACKET:
        return true;
      default:
        return false;
    }
  }


  // Welds open-boundary vertices whose gap is a small fraction of the local average
  // *boundary* edge length. Interior vertices (shared by 2+ triangles) are never touched.
  // Expects an indexed geometry (call mergeVertices first).
  //
  // Using boundary-only edge lengths as the scale reference is critical: interior edges
  // can be far longer than the circle arc step (e.g. a coarse plate triangle behind a
  // small circle). Including them in the average inflates the threshold and incorrectly
  // merges adjacent circle vertices. Boundary edges are always the actual discretization
  // step we want to stay below.
  private static connectRepairElementGeometry(geometry: BufferGeometry, fraction = 0.05): BufferGeometry {
    if (!geometry.index) return geometry;

    const pos = geometry.attributes['position'] as THREE.BufferAttribute;
    const idx = Array.from(geometry.index.array) as number[];
    const nv = pos.count;
    const nf = idx.length / 3;

    // Count triangle references per edge (normalised min→max key).
    const edgeRefs = new Map<string, number>();
    for (let i = 0; i < nf; i++) {
      const a = idx[i * 3], b = idx[i * 3 + 1], c = idx[i * 3 + 2];
      for (const [u, v] of [[a, b], [b, c], [a, c]] as [number, number][]) {
        const k = u < v ? `${u}|${v}` : `${v}|${u}`;
        edgeRefs.set(k, (edgeRefs.get(k) ?? 0) + 1);
      }
    }

    // Boundary vertex = on at least one open edge (referenced by exactly 1 triangle).
    const isBoundary = new Uint8Array(nv);
    for (const [key, count] of edgeRefs) {
      if (count === 1) {
        const sep = key.indexOf('|');
        isBoundary[+key.slice(0, sep)] = 1;
        isBoundary[+key.slice(sep + 1)] = 1;
      }
    }

    const boundaryVerts: number[] = [];
    for (let i = 0; i < nv; i++) if (isBoundary[i]) boundaryVerts.push(i);

    // Precompute average *boundary* edge length at each boundary vertex.
    // Boundary edges (count === 1) are the real discretization steps: circle arc segments,
    // plate-clip intersection edges, etc. Interior edges are irrelevant and must not
    // dilate the threshold.
    const bndEdgeLenSum = new Float64Array(nv);
    const bndEdgeLenCnt = new Uint32Array(nv);
    for (const [key, count] of edgeRefs) {
      if (count !== 1) continue;
      const sep = key.indexOf('|');
      const u = +key.slice(0, sep);
      const v = +key.slice(sep + 1);
      const dx = pos.getX(u) - pos.getX(v);
      const dy = pos.getY(u) - pos.getY(v);
      const dz = pos.getZ(u) - pos.getZ(v);
      const len = Math.sqrt(dx * dx + dy * dy + dz * dz);
      bndEdgeLenSum[u] += len; bndEdgeLenCnt[u]++;
      bndEdgeLenSum[v] += len; bndEdgeLenCnt[v]++;
    }
    const avgBndEdgeLen = new Float64Array(nv);
    for (let i = 0; i < nv; i++)
      avgBndEdgeLen[i] = bndEdgeLenCnt[i] > 0 ? bndEdgeLenSum[i] / bndEdgeLenCnt[i] : 0;

    // Union-Find with path-halving.
    const parent = new Int32Array(nv);
    for (let i = 0; i < nv; i++) parent[i] = i;

    const find = (x: number): number => {
      while (parent[x] !== x) { parent[x] = parent[parent[x]]; x = parent[x]; }
      return x;
    };

    // Merge boundary vertex pairs whose distance < fraction * min(local avg boundary edge length).
    // Floating-point seam gaps are always orders of magnitude smaller than any boundary edge,
    // so fraction=0.05 closes gaps without ever touching real circle or clip edges.
    const bc = boundaryVerts.length;
    for (let i = 0; i < bc; i++) {
      const vi = boundaryVerts[i];
      const ax = pos.getX(vi), ay = pos.getY(vi), az = pos.getZ(vi);
      const localTolI = avgBndEdgeLen[vi] * fraction;
      for (let j = i + 1; j < bc; j++) {
        const vj = boundaryVerts[j];
        const localTol = Math.min(localTolI, avgBndEdgeLen[vj] * fraction);
        const dx = ax - pos.getX(vj), dy = ay - pos.getY(vj), dz = az - pos.getZ(vj);
        if (dx * dx + dy * dy + dz * dz < localTol * localTol) {
          const ra = find(vi), rb = find(vj);
          if (ra !== rb) parent[ra] = rb;
        }
      }
    }

    // Each vertex maps to its canonical root.
    const remap = new Int32Array(nv);
    for (let i = 0; i < nv; i++) remap[i] = find(i);

    // Compact: keep only canonical vertices still referenced after remap.
    const used = new Uint8Array(nv);
    for (let i = 0; i < idx.length; i++) used[remap[idx[i]]] = 1;

    const compact = new Int32Array(nv);
    const outPos: number[] = [];
    for (let i = 0; i < nv; i++) {
      if (!used[i]) continue;
      compact[i] = outPos.length / 3;
      outPos.push(pos.getX(i), pos.getY(i), pos.getZ(i));
    }

    const outIdx: number[] = [];
    for (let i = 0; i < nf; i++) {
      const a = compact[remap[idx[i * 3]]];
      const b = compact[remap[idx[i * 3 + 1]]];
      const c = compact[remap[idx[i * 3 + 2]]];
      if (a !== b && b !== c && a !== c) outIdx.push(a, b, c);
    }

    const result = new BufferGeometry();
    result.setAttribute('position', new THREE.BufferAttribute(new Float32Array(outPos), 3));
    const useUint32 = outPos.length / 3 > 65535;
    result.setIndex(new THREE.BufferAttribute(
      useUint32 ? new Uint32Array(outIdx) : new Uint16Array(outIdx), 1
    ));
    result.computeVertexNormals();
    result.computeBoundingBox();
    result.computeBoundingSphere();
    return result;
  }

}
